import React from 'react';
import PropTypes from 'prop-types';
import Pficon from 'components/Pficon';

const QuestionPrompt = ({ icon, renderPrompt, label, className = '' }) => (
  <div className={`color-grey-10 ${className}`}>
    <div className="flex ">
      <Pficon
        className="position-relative margin-right-xs"
        type={icon}
        style={{ top: '2px', fontSize: '15px' }}
      />
      <span className="text-weight-bold margin-right-sm">{label}</span>
      {renderPrompt()}
    </div>
  </div>
);

QuestionPrompt.propTypes = {
  icon: PropTypes.string.isRequired,
  renderPrompt: PropTypes.func.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
};

export default QuestionPrompt;
